module.exports = __webpack_public_path__ + "img/service-icon4.dea673c4.png";